import Rollbar from 'rollbar';
import { trevorAxios } from '@/api';

const APP_INFO_ENDPOINT = '/actuator/info';
const USER_INFO_ENDPOINT = '/api/v1/me';

const ROLLBAR_ENVS = ['trevor-prod'] as const;

let rollbarInstance: Rollbar;

const getUserInfo = () => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const userInfo = window.userInfo;
  if (userInfo) {
    return Promise.resolve({
      data: {
        email: userInfo,
      },
    });
  }

  return trevorAxios.get(USER_INFO_ENDPOINT);
};

const rollbarMock = {
  error: (_message: string, error: Error) => window.console.error(error),
} as Rollbar;

export const RollbarApi = Promise.all([
  trevorAxios.get(APP_INFO_ENDPOINT),
  getUserInfo(),
])
  .then(([{ data: app }, { data: user }]) => {
    if (!ROLLBAR_ENVS.includes(app.app.environment)) return rollbarMock;

    if (rollbarInstance) return rollbarInstance;
    rollbarInstance = new Rollbar({
      accessToken: 'b01fe7a84d5f45cca136a20e4ae0b665',
      captureUncaught: true,
      captureUnhandledRejections: true,
      checkIgnore: (isUncaught, args, payload) => {
        // Determine whether or not to send the payload to the Rollbar API
        // return true to ignore the payload
        const url = new URL((payload as any).request.url);
        return ![window.location.host].includes(url.host);
      },
      payload: {
        environment: app.environment,
        client: {
          javascript: {
            source_map_enabled: true,
            code_version: app.version,
            guess_uncaught_frames: true,
          },
        },
        person: {
          id: user.email,
          email: user.email,
        },
      },
    });

    return rollbarInstance;
  })
  .catch(window.console.error);
